import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import type { VisibilityLevel } from '@recruitee/visibility-types';

@Injectable()
export class VisibilitySelectorAnalytics extends AnalyticsBase {
  public namespace = 'Visibility';
  public requireViewContext = true;

  public trackDropdownOpen() {
    this.track('DropdownOpen');
  }

  public trackChange(params: { level: VisibilityLevel; selectedMembersCount: number }) {
    this.track('Change', params);
  }
}
